<template>
  <div class="user-kana detail-item" v-if="editingData">

    <div class="head"><b>フリガナ</b></div>
    <div class="data">
      <p>{{ editingData.kana ? editingData.kana : '-' }}</p>
      <p class="current-data" v-if="currentData?.kana">{{ currentData.kana }}</p>
    </div>
    
  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    }
  },
  setup() {
    const { getError } = useForm();

    return {
      getError
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-detail.scss';

</style>
